/**
 * Simulation state types
 */

export type SimulationStatus =
  | 'empty'
  | 'loading'
  | 'ready'
  | 'running'
  | 'paused'
  | 'error';

export interface SimulationState {
  id: string;
  status: SimulationStatus;
  tick: number;
  entityCount: number;
  fps: number;
  scenarioName: string | null;
  temperature: number;
  dt: number;
}

export interface CellPosition {
  row: number;
  col: number;
}

export function cellIdFromPosition(pos: CellPosition): string {
  return `cell-${pos.row}-${pos.col}`;
}

export function positionFromCellId(id: string): CellPosition | null {
  const match = id.match(/^cell-(\d+)-(\d+)$/);
  if (!match) return null;
  return {
    row: parseInt(match[1], 10),
    col: parseInt(match[2], 10),
  };
}
